var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#5570F1",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.998 21C46.1943 20.9999 46.3879 21.046 46.5631 21.1346C46.7383 21.2232 46.8901 21.3518 47.0063 21.51L47.098 21.655L52.5363 31.7017L52.5997 31.8567L52.6197 31.9233L52.653 32.0933L52.663 32.25C52.6631 32.3626 52.648 32.4748 52.618 32.5833L52.5397 32.7917L52.4763 32.9067C52.4395 32.9667 52.3977 33.0236 52.3513 33.0767L52.4513 32.9467L52.4097 33.005L36.993 50.5133C36.865 50.6836 36.6942 50.817 36.498 50.9L36.3347 50.955L36.2047 50.9833L35.9997 51L35.833 50.99L35.6363 50.9467C35.5345 50.9174 35.437 50.8749 35.3463 50.82L35.3313 50.8083C35.2522 50.7597 35.1795 50.7015 35.1147 50.635L19.6313 33.0583L19.588 33.005L19.5213 32.9067C19.4269 32.7542 19.3666 32.583 19.3447 32.405L19.333 32.25L19.338 32.14L19.3597 31.9917C19.3701 31.9431 19.3834 31.8952 19.3997 31.8483L19.4363 31.75L19.483 31.655L24.8997 21.655C24.9931 21.4824 25.1258 21.3343 25.287 21.2225C25.4483 21.1107 25.6336 21.0385 25.828 21.0117L25.998 21H45.998ZM40.9947 33.5H30.9963L35.9963 46.3117L40.9947 33.5ZM28.3147 33.5H23.348L32.2663 43.6233L28.3147 33.5ZM48.6447 33.5H43.6797L39.733 43.6167L48.6447 33.5ZM30.9513 23.5H26.7413L22.678 31H28.5513L30.9513 23.5ZM38.418 23.5H33.5763L31.1747 31H40.8163L38.4163 23.5H38.418ZM45.2513 23.5H41.043L43.443 31H49.313L45.2513 23.5Z",
    fill: "#40499D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolPaymentIcon);
export default __webpack_public_path__ + "static/media/SchoolPaymentIcon.d4571462f85da8707f95c27d341af5fc.svg";
export { ForwardRef as ReactComponent };